(function(){
  'use strict';

  angular
    .module('app')
    .controller('HomeController', HomeController);

  function HomeController(API, $filter, $scope){
    let vm = this;

    vm.$onInit = () => {
      _loadFromApi();
      _sliders();
    }

    function _loadFromApi() {
      _loadCategoriesProducts();
      _loadCommentaries();
    }

    function _sliders() {
      //Intervalo com que a função nextSlider será chamada
      let interval = setInterval(() => {
        nextSlider();
      }, 4000);

      //Ao redimensionar janela, chama a função novamente
      window.onresize = function(){
        nextSlider();
      }

      //Define a imagem do slider inicial e passa os slides
      function nextSlider(){
        let banners = document.querySelectorAll('.home-main-screen');
        let isActualSliderActive = false;
        var screenWidth = window.innerWidth;

        banners.forEach(element => {
          if (element.classList.contains('home-main-screen--active')) {
            isActualSliderActive = true;
            element.classList.remove('home-main-screen--active');
          } else if (isActualSliderActive) {
            //Verifica o tamanho da tela para ativar os sliders mobile ou desktop
            if((screenWidth > 768 && element.classList.contains('hidden-sm-down')) || (screenWidth <= 768 && element.classList.contains('hidden-md-up'))){
             element.classList.add('home-main-screen--active');
              isActualSliderActive = false;
            }
          }
        });

        if (isActualSliderActive) {
          //Verifica o tamanho da tela para ativar os sliders mobile ou desktop
          if(screenWidth > 768){
            var mediaBanners = document.querySelectorAll('.home-main-screen.hidden-sm-down');
          }else{
            var mediaBanners = document.querySelectorAll('.home-main-screen.hidden-md-up');
          }
          mediaBanners[0].classList.add('home-main-screen--active');
          isActualSliderActive = false;
        }
      }

      $scope.$on('$destroy', () => {
        clearInterval(interval);
      })
    }

    function _loadCategoriesProducts() {
      API.get('produto_brastelha/categoria')
        .then(result => result.data)
        .then(categories => vm.listProducts = categories.filter(c => {
          return c.slug.toUpperCase() != 'BRAS-X'
        }))
        .catch(error => {
          console.log(error, 'error');
          //$state.go('news');
        });
    }

    function _loadCommentaries() {
      API.get('produto')
        .then(result => result.data)
        .then(commentaries => vm.commentaries = commentaries.map(commentary => {
          commentary.profileImage = $filter('imgUrl')(commentary.imagem_produto);
          return commentary;
        }))
        .catch(error => {
          vm.commentaries = [{error: true}];
        });
    }

  }

})();
